import {Api} from "@/common/api/Api";
import {axiosInstance} from "@/plugins/axios";
import CustomerRouter from "@/context/customer/router/CustomerRouter";
import {LocationAutocompleteView} from "@/context/location/model/LocationAutocompleteView";
import {AxiosInstance, AxiosResponse} from "axios";
import AutocompleteApi from "@/common/api/AutocompleteApi";
import RemoteConfigurationRouter
  from "@/context/remote_configuration/router/RemoteConfigurationRouter";

export class RemoteConfigurationApi extends Api {
  constructor(axios: AxiosInstance) {
    super(RemoteConfigurationRouter.BASE_PATH, axios);
  }

  public static async findIdentifierAutocomplete(
    search: string,
    query: string
  ): Promise<Array<LocationAutocompleteView>> {
    const response: AxiosResponse = await AutocompleteApi.findAutocomplete(
      RemoteConfigurationRouter.BASE_PATH + '/identifier',
      search,
      query
    );
    return response.data;
  }

  public static async uploadConfiguration(
    data: any
  ): Promise<Array<LocationAutocompleteView>> {
    console.log(data);
    let formData = new FormData();
    formData.append('file', data.file);
    formData.append('identifier', data.identifier);
    const response = await axiosInstance.post(
      RemoteConfigurationRouter.BASE_PATH + '/upload-configuration', formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response.data;
  }

  public static async downloadConfiguration(
    data: any
  ): Promise<BlobPart> {
    console.log(data)
    const response = await axiosInstance.get(
      RemoteConfigurationRouter.BASE_PATH + '/download-configuration',
      {
        params: {identifier: data.identifier},
        responseType: 'blob' // Important to ensure the response is handled as a binary file
      }
    );
    return response.data;
  }

  public static async findUploadInformation(
    data: any
  ): Promise<any> {
    console.log(data)
    const response = await axiosInstance.get(
      RemoteConfigurationRouter.BASE_PATH + '/upload-information', {params: {id: data}}
    );
    return response.data;
  }

  public static async findConfigurationAutocomplete(
    search: string,
    query: string
  ): Promise<Array<LocationAutocompleteView>> {
    const response: AxiosResponse = await AutocompleteApi.findAutocomplete(
      RemoteConfigurationRouter.BASE_PATH + '/configuration',
      search,
      query
    );
    return response.data;
  }
}

export const remoteConfigurationApi = new RemoteConfigurationApi(axiosInstance);
